import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './SearchComponent.css'

const SearchComponent: React.FC = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate();
    const handleSearch = () => {
        navigate(`/search?query=${searchQuery}`);
      };

  return (
    <div className='header'>
        <div className="search-bar">
          <input type="text" placeholder="Enter domain name or relevant domain parameter"
           value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)} />
          <button className="search-button"  onClick={handleSearch}>Search domains</button>
      </div>
    </div>
  );
};

export default SearchComponent;